import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row d-flex justify-content-center" }
const _hoisted_2 = { class: "col-12 text-center" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "col-12 col-sm-10 col-md-8 col-lg-8 col-xl-6 d-grid gap-2"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "row d-flex justify-content-center"
}
const _hoisted_11 = {
  style: {"min-height":"32px"},
  class: "d-flex"
}
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "row d-flex justify-content-center" }
const _hoisted_14 = { class: "col-12 col-sm-10 col-md-8 col-lg-8 col-xl-6 d-grid gap-2" }

import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useWidget } from "../../composables/useWidget";
import { useStore } from "../../models/Store/store";
import { useTenantConfig } from "../../composables/useTenantConfig";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserChoice',
  setup(__props) {

const { showBtnBookPro, hasCheckinOnline } = useTenantConfig();
const router = useRouter();
const store = useStore();
const { labelPro } = useWidget();
const { t } = useI18n();
const tenantConfig = useTenantConfig();

const showBtnBookService = ref(false);

onMounted(() => {
    store.bookedit = null;
    store.clearHistorySteps();
    store.pageAsGoToHome = null;

    showBtnBookService.value = true;
});

const goToNextStep = () => {
    const serviceRouteSelection = tenantConfig.getRouteNameServiceSelection();
    router.push({ name: serviceRouteSelection });
};

const goToProStep = () => {
    router.push({ name: "probook" });
};

const goToEditBook = () => {
    router.push({ name: "editbook" });
};

const tenantAlerts = computed(() => {
    var stepsMade = store.stepsMade;
    if (stepsMade.municipality) {
        return store.tenantSelected.alerts.filter((c) => !c.city || c.city.toLowerCase() === stepsMade.municipality.toLowerCase());
    } else {
        return store.tenantSelected.alerts.filter((c) => !c.city);
    }
});

const hasBlockingAlert = computed(() => {
    return tenantAlerts.value.filter((c) => c.typeId === 2).length > 0;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(showBtnBookPro))
          ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_unref(t)("titles.whoAreYou")), 1))
          : (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(_unref(t)("titles.whatToDo")), 1))
      ]),
      (showBtnBookService.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-lg my-3",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (goToNextStep())),
              disabled: hasBlockingAlert.value
            }, [
              _createElementVNode("div", null, [
                (_unref(showBtnBookPro))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(t)("common.privatePerson")) + "/" + _toDisplayString(_unref(t)("common.company")), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(t)("titles.newBooking")), 1))
              ])
            ], 8, _hoisted_6)
          ]))
        : _createCommentVNode("", true),
      (_unref(showBtnBookPro))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "col-12 col-sm-10 col-md-8 col-lg-8 col-xl-6 d-grid gap-2",
            disabled: hasBlockingAlert.value
          }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-lg my-3",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (goToProStep()))
            }, [
              _createElementVNode("div", null, _toDisplayString(_unref(labelPro)), 1)
            ])
          ], 8, _hoisted_9))
        : _createCommentVNode("", true)
    ]),
    (tenantAlerts.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tenantAlerts.value, (item, alertIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: alertIndex,
              class: _normalizeClass(["text-center alert col-12 col-sm-10 col-md-8 col-lg-8 col-xl-6 d-grid gap-2", item.typeId === 1 ? 'alert-warning' : 'alert-danger']),
              role: "alert"
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", {
                  class: "align-self-center",
                  innerHTML: item.message
                }, null, 8, _hoisted_12)
              ])
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline-primary btn-sm my-3",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (goToEditBook()))
        }, [
          _createElementVNode("div", null, _toDisplayString(_unref(t)("titles.editDeleteBooking")), 1)
        ])
      ])
    ])
  ]))
}
}

})